import type { IField } from '../../services/metadataService';

// Configured fields keep their identity so saved answers remain readable.
export const orderComponentFieldName = (field: IField, componentCode: string) =>
  field.componentCode || !componentCode
    ? field.name
    : `OrderComponent_${componentCode}`;
